import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import classnames from "classnames/bind";

import styles from "./AddToBasketButton.module.scss";

const cx = classnames.bind(styles);

type AddToBasketButtonProps = {
  disabled: boolean;
  isSubmitting: boolean;
  handleAddToBasketClick: () => void;
  buttonText?: string;
  ref?: React.Ref<HTMLButtonElement>;
  className?: string;
  ctaPremiumDesign?: boolean;
};

export const AddToBasketButton = ({
  disabled,
  handleAddToBasketClick,
  isSubmitting,
  buttonText = "Add to basket",
  ref,
  className,
  ctaPremiumDesign = false,
}: AddToBasketButtonProps) => {
  return (
    <PrimaryButton
      // small hack for TS not understanding the ref passed to button
      {...(ref ? { ref } : {})}
      id="basket:add:button"
      className={cx("button", className, {
        nonPremiumButton: !ctaPremiumDesign,
      })}
      disabled={disabled}
      submitting={isSubmitting}
      onClick={handleAddToBasketClick}
      data-testid="basket:add"
      labelText={buttonText}
      width={"full-width"}
    />
  );
};
